module.exports = __webpack_public_path__ + "assets/img/button-blue.3a011013.png";